module.exports = __webpack_public_path__ + "img/class-rate.037d4557.png";